import type { BaseParams } from "../../../../client.types.js";
import type {
    IVerifyInvoiceBody,
    IVerifyInvoiceResponse200,
} from "../../../../routes/private/Ambassadors/Wallets/VerifyInvoice/VerifyInvoice.interfaces.js";
import { createAxiosRoute } from "../../../../utils/createAxiosRoute.js";

export const verifyInvoice = (p: BaseParams) =>
    createAxiosRoute<
        {
            body: IVerifyInvoiceBody;
        },
        IVerifyInvoiceResponse200
    >({
        ...p,
        method: "post",
        path: "/api/ambassadors/wallets/verifyInvoice",
    });
